export default class StringUtils{
    static toBrazilianDecimalFormat(value: number){
        if (!value) return null;
        const numberValue = Number(value); // Convertendo para número
        return numberValue.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2 });
    }


    static formatarPlaca(str: string) {
        if(!str) return null
        const part1 = str.substr(0, 3);
        const part2 = str.substr(3);
        return `${part1}-${part2}`;
    }

    static formatToBRL(number: number) {
        if(!number) return null
        return number.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
    static formatCPF(cpf: string | undefined) {
        if(!cpf) return '-------'
        const part1 = cpf?.substr(0, 3);
        const part2 = cpf?.substr(3, 3);
        const part3 = cpf?.substr(6, 3);
        const part4 = cpf?.substr(9, 2);
        return `${part1}.${part2}.${part3}-${part4}`;
    }

    static formatCNPJ(cnpj: string | undefined) {
        if (!cnpj) return '------------';
        const part1 = cnpj.substr(0, 2);
        const part2 = cnpj.substr(2, 3);
        const part3 = cnpj.substr(5, 3);
        const part4 = cnpj.substr(8, 4);
        const part5 = cnpj.substr(12, 2);
        return `${part1}.${part2}.${part3}/${part4}-${part5}`;
    }
    static formatToBrazilianShortDateTime(dateString: string) {
        const date = new Date(dateString?.replace('Z',''));
        const options = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' };
        //@ts-ignore
        return date.toLocaleString('pt-BR', options);
    }
    static decimalToPercentSeparatedByComma(value: number) {
        if(!value) return null
        const valueAsString = value.toString();
        const parts = valueAsString.split('.');
        const integerPart = parts[0];
        const decimalPart = parts[1] ?? "00";
        return `${integerPart},${decimalPart}%`;
    }
}